import "./module/userAgentChecker.min.js"
import "./module/plugin.js"

require('./module/ofi.min.js');

import Swiper from 'swiper/bundle';
var swiper = new Swiper('.mv__slide', {
    speed: 3500,
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    }
});